var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filters),function(data,slug){return _c(_vm.getComponentName(data.type),{key:slug+Math.random(),tag:"component",attrs:{"data":data}})}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd6cbda6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/catalog/assets/js/components/CatalogDynamicFilters.vue
// module id = c4AJ
// module chunks = 0